import React, { useCallback, useEffect, useState } from "react";
import Menu from "../../components/menu/menu.jsx";
import Busca from "../../components/busca/busca.jsx";
import Indicador from "../../components/indicador/indicador.jsx";
import Grafico from "../../components/grafico/grafico.jsx";
import api from "../../services/api.js";
import "../../style/global.css";

function Dashboard() {
  const [dadosIndicadores, setDadosIndicadores] = useState({
    receitas_mes: 0,
    qtd_rec_mes: 0,
    receitas_dia: 0,
    qtd_rec_dia: 0,
  });
  const [dadosAnual, setDadosAnual] = useState([["Mes", "Valor"], [0, 0]]);

  const montarDashboard = useCallback(async () => {
    try {
      const [dailyResponse, monthlyResponse] = await Promise.all([
        api.get("/admin/dashboard/faturamento-dia"),
        api.get("/admin/dashboard/faturamento-mensal"),
      ]);

      const dailySummary = dailyResponse.data?.summary || {};
      const monthlySummary = monthlyResponse.data?.summary || {};
      const monthlyItems = monthlyResponse.data?.items || [];

      setDadosIndicadores({
        receitas_mes: monthlySummary.totalRevenue || 0,
        qtd_rec_mes: monthlySummary.totalOrders || 0,
        receitas_dia: dailySummary.totalRevenue || 0,
        qtd_rec_dia: dailySummary.totalOrders || 0,
      });

      const chartRows = monthlyItems.map((item) => [
        item.label || `${item.month}/${item.year}`,
        Number(item.total || 0),
      ]);

      setDadosAnual(chartRows.length > 0 ? [["Mes", "Valor"], ...chartRows] : [["Mes", "Valor"], [0, 0]]);
    } catch (err) {
      setDadosIndicadores({
        receitas_mes: 0,
        qtd_rec_mes: 0,
        receitas_dia: 0,
        qtd_rec_dia: 0,
      });
      setDadosAnual([["Mes", "Valor"], [0, 0]]);
      alert("Erro ao carregar dashboard.");
    }
  }, []);

  useEffect(() => {
    montarDashboard();
  }, [montarDashboard]);

  return (
    <>
      <div className="container-fluid">
        <div className="row flex-nowrap">
          <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
            <Menu page="dashboard" />
          </div>

          <div className="col py-3 me-3">
            <div className="mb-5">
              <Busca texto="Digite o nome do associado" />
            </div>

            <div className="d-flex justify-content-between">
              <h2>Dashboard</h2>
              <button onClick={montarDashboard} className="btn btn-primary ms-4">
                Atualizar
              </button>
            </div>

            <div className="row">
              <div className="col-md-3 mt-4">
                <Indicador
                  titulo="Recebidos no mes"
                  valor={new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(dadosIndicadores.receitas_mes)}
                  rodape={`${dadosIndicadores.qtd_rec_mes} titulos`}
                />
              </div>

              <div className="col-md-3 mt-4">
                <Indicador
                  titulo="Recebidos no dia"
                  valor={new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(dadosIndicadores.receitas_dia)}
                  rodape={`${dadosIndicadores.qtd_rec_dia} titulos`}
                />
              </div>

              <div className="col-12 mt-5">
                <Grafico
                  titulo="Grafico de Faturamento"
                  chartType="Line"
                  dados={dadosAnual}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
